<template>
  <div>
    <RenderProps
      class="mt-4"
      v-for="(component, i) in components"
      :key="`${component.name}-${i}`"
      :props="component.props"
      :component-name="component.componentName"
    >
      <div v-if="!component.name" v-html="component.content"></div>
    </RenderProps>
  </div>
</template>

<script lang="ts">
import RenderProps from './article-render-props'

export default {
  name: 'KftParsedArticle',
  components: {
    RenderProps,
  },
  props: {
    components: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
